<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">协议详情</h4>
      </div>

      <div class="title-little-subheading">
        框架协议信息
      </div>
      <el-form ref="form" :model="form" label-width="145px" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="框架协议编号:"
              ><span>{{ form.code }}</span></el-form-item
            >
          </el-col>
          <el-col :span="12">
            <el-form-item label="框架协议标题:"
              ><span>{{ form.name }}</span></el-form-item
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="购买商:"
              ><span>{{ form.supplierName }}</span></el-form-item
            >
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始有效期:"
              ><span>{{ form.startTime }}</span></el-form-item
            >
          </el-col>
        </el-row>
        <el-form-item label="截止有效期:"
          ><span>{{ form.endTime }}</span></el-form-item
        >
        <el-table
          :data="form.agreementMateVOList"
          style="width: 80%;margin:20px auto"
          border
        >
          <el-table-column label="序号" width="60" type="index" align="center">
          </el-table-column>
          <el-table-column
            prop="className"
            label="物资分类"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="计量单位"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="agPrice"
            label="协议价格(元)"
            align="center"
            width="250"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-form-item label="调价规则:"
          ><span>{{ form.priceChangeRule }}</span></el-form-item
        >
      </el-form>
      <div class="page-index-footer">
        <el-button @click="onClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { closeCurrentPage } from '@/utils/constantime'
export default {
  components: {},
  data() {
    return {
      form: { mates: [{ id: 1 }, { id: 2 }] },
      tableData: []
    }
  },
  created() {
    // this.getEntrustPlan()
    this.getAgreementVO()
  },
  methods: {
    async getAgreementVO() {
      let param = {
        agreementId: this.$route.query.agreementId,
        buyerCompCode: this.$route.query.buyerCompCode
      }
      let data = await this.$api.order.getAgreementVO(param)
      this.form = data
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    onClose() {
      closeCurrentPage()
    }
  }
}
</script>
